import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import styles from "./SearchInput.module.css";

const SearchInput = ({ value, onChange, placeholder, className }) => {
	return (
		<div className={`${styles.searchContainer} ${className || ""}`}>
			<FontAwesomeIcon icon={faSearch} className={styles.searchIcon} />
			<input
				type="text"
				className={styles.searchInput}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
			/>
		</div>
	);
};

export default SearchInput;
